export const copilotDropdownFeatureFlags = [
  'email-translation',
  'agent-copilot-auto-translate',
  'agent-copilot-pin-actions',
] as const;
